var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import Cookies from 'js-cookie';
import Bowser from 'bowser';
import { getCookieDomain } from '@bombas/react/util';
import { isBrowser } from '../ssr';
var OPTIMIZELY_USER_ATTR_COOKIE = 'optimizely_user_attr';
/**
 * Get the device attributes for the user.
 */
export var getDeviceAttrs = function (userAgent) {
    var browser = Bowser.getParser(userAgent);
    return {
        Device: browser.getPlatformType() || '',
        Browser: browser.getBrowserName() || ''
    };
};
/**
 * Helper function that gets a user’s user-level attributes.
 * It uses a session cookie on the client to ensure attributes are consistent.
 */
export var getUserAttributes = function (req) {
    var _a;
    if (!isBrowser() && req) {
        var userAgent = req.headers['user-agent'] || '';
        var isReturningUser = !!((_a = req.cookies) === null || _a === void 0 ? void 0 : _a.optimizelyNewCustomerOfferEmailCaptureImpression);
        return __assign(__assign({}, getDeviceAttrs(userAgent)), { IsReturningUser: isReturningUser });
    }
    if (isBrowser()) {
        var existingCookie = Cookies.get(OPTIMIZELY_USER_ATTR_COOKIE);
        if (existingCookie) {
            try {
                return JSON.parse(existingCookie);
            }
            catch (e) {
                // eslint-disable-next-line
                console.error('Failed to parse Optimizely user attributes cookie', e);
            }
        }
        var attributes = __assign(__assign({}, getDeviceAttrs(window.navigator.userAgent)), { IsReturningUser: !!Cookies.get('optimizelyNewCustomerOfferEmailCaptureImpression') });
        Cookies.set(OPTIMIZELY_USER_ATTR_COOKIE, JSON.stringify(attributes), {
            domain: getCookieDomain(),
            sameSite: 'Lax'
        });
        return attributes;
    }
    return {};
};
